import { useState, Fragment } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import CustomActionCell from 'Presentation/Components/Table/Components/CustomActionCell'
import moment from 'moment'

const ViewModel = () => {
  const { id } = useParams<{ id: string }>()
  const { projectData, getProject, removeNote, downloadFileNote } = useProjectStore(
    state => ({
      projectData: state.selected,
      getProject: state.getOne,
      removeNote: state.removeNote,
      downloadFileNote: state.downloadFileNote,
    }),
    shallow
  )

  const [isOpenCreateNoteModal, setIsOpenCreateNoteModal] = useState(false)

  const data: any[] = projectData?.projectNotes ?? []

  const fetchProject = () => {
    getProject(parseInt(id ?? ''))
  }

  const onRemoveNote = (noteId: any) => {
    Swal.fire({
      title: 'คุณต้องการลบบันทึกเหตุการณ์นี้ใช่หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const { success, data } = await removeNote(parseInt(id ?? ''), noteId)
          if (success) {
            toast.success('ลบบันทึกเหตุการณ์สำเร็จ')
            fetchProject()
          } else {
            toast.error(data?.message || data || 'ลบบันทึกเหตุการณ์ไม่สำเร็จ')
          }
        } catch (error) {
          toast.error('ลบบันทึกเหตุการณ์ไม่สำเร็จ')
        }
      }
    })
  }

  const onAfterSaveNote = () => {
    fetchProject()
    setIsOpenCreateNoteModal(false)
  }

  const columns: any[] = [
    {
      Header: 'วันที่บันทึก',
      accessor: 'recordedAt',
      width: 200,
      minWidth: 200,
      disableSortBy: false,
      Cell: ({ value }: any) => (
        <span className='text-gray-800'>
          {moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY Hh:mm')}
        </span>
      ),
    },
    {
      Header: 'บันทึกข้อความ',
      accessor: 'note',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'บันทึกโดย',
      accessor: 'noteBy',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'ไฟล์แนบ',
      accessor: 'attachments',
      width: 200,
      minWidth: 200,
      Cell: ({ value, row }: any) => {
        const files: any[] = value
        return (
          <Fragment>
            {files.length === 0 && <span className='text-gray-800'>-</span>}

            {files.length > 0 &&
              files.map((file, index) => (
                <div key={index}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href={'#'}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 underline'
                    onClick={async e => {
                      e.preventDefault()
                      await downloadFileNote(
                        parseInt(id ?? ''),
                        row.original.id,
                        file.id,
                        file.documentName
                      )
                    }}>
                    {file.documentName}
                  </a>
                </div>
              ))}
          </Fragment>
        )
      },
    },
    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <CustomActionCell
          id={row.original.id}
          hideView
          hideEdit
          hideDuplicate
          onClickDelete={() => {
            onRemoveNote(row.original.id)
          }}
        />
      ),
    },
  ]

  return {
    data,
    columns,
    isOpenCreateNoteModal,
    setIsOpenCreateNoteModal,
    onAfterSaveNote,
  }
}

export default ViewModel
